import { Images } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import CounterText from '../game/CounterText';
import NumberTile from '../game/NumberTile';
import PlayingGrid from '../game/PlayingGrid';
import TextTimer from '../game/TextTimer';
import gameData from '../gameData';
import { ADDITION, MULTIPLICATION } from '../gameParts';
import BonusScreen from './BonusScreen';

export default class GameScreen extends Phaser.Scene {
  static get KEY() { return 'GameScreen'; }

  create() {

    this.soundCounter = 0;

    this.currentSentenceValue = gameData.gameType === ADDITION ? 0 : 1;

    this.bonusTimeSign = null;
    this.currentBonusValue = 0;

    this.targetNumberSign = null;
    this.currentTargetNumberValue = 0;

    this.scoreSign = null;

    this.sentenceArea = null;
    this.starsCollected = 0;

    Images.addImage(0, 0, 'yellow_background', this).setOrigin(0);

    const width = this.scale.width;
    const height = this.scale.height;

    this.bonusTimeSign = Images.addImage(150, 48, 'bonus_time_sign', this);

    this.textTimer = new TextTimer(this, 28, '#FFF');
    this.textTimer.x = 150;
    this.textTimer.y = 50;
    this.add.existing(this.textTimer);
    this.textTimer.start(100);

    this.targetNumberSign = new CounterText(this, '_VALUE_', 34, '#fff', 'target_number_sign');
    this.targetNumberSign.x = width / 2;
    this.targetNumberSign.y = this.targetNumberSign.getBounds().height / 2;
    this.targetNumberSign.setValue(this.currentTargetNumberValue);
    this.add.existing(this.targetNumberSign);
    this.targetNumberSign.animateNumbers = true;

    this.scoreSign = new CounterText(this, '_VALUE_', 32, '#fff', 'score_sign_round');
    this.scoreSign.x = width - 150;
    this.scoreSign.y = this.scoreSign.getBounds().height / 2;
    if (gameData.gameType === MULTIPLICATION) this.scoreSign.y -= 6;
    this.scoreSign.setValue(0);
    this.add.existing(this.scoreSign);

    this.playingGrid = new PlayingGrid(this);
    this.playingGrid.x = (width / 2) - (this.playingGrid.sprite.width / 2);
    this.playingGrid.y = (height / 2) - (this.playingGrid.sprite.height / 2);
    this.add.existing(this.playingGrid);
    this.playingGrid.currentLevel = gameData.CURRENT_LEVEL;
    this.playingGrid.setupInitialBoard(false);
    this.playingGrid.on(NumberTile.TILE_SELECTED, (value) => {this.tileClicked(value);});
    this.playingGrid.on(PlayingGrid.TILES_ERASED, () => this.tilesErased());
    this.playingGrid.on(PlayingGrid.TARGET_HIT, (value) => {this.targetHit(value);});
    this.playingGrid.on(PlayingGrid.STAR_COLLECTED, () => {this.starsCollected++;});
    this.playingGrid.on(PlayingGrid.LEVEL_COMPLETED, () => {this.levelCompleted();});

    this.sentenceArea = new CounterText(this, '_VALUE_', 28, '#fff', 'number_sentence_area');
    this.sentenceArea.x = width / 2;
    this.sentenceArea.y = height - 70;
    this.sentenceArea.textLabel.setOrigin(.5, 1);
    this.sentenceArea.textLabel.y += 7;
    this.sentenceArea.setValue('');
    this.add.existing(this.sentenceArea);

    const targetNumber = this.playingGrid.findValidTargetNumber();
    this.targetNumberSign.setValue(targetNumber);
  };

  tileClicked(value) {

    const len = this.sentenceArea.getValue().length;

    if (len < 39) {

      if (len === 0) {
        this.sentenceArea.addValue(`${value}`);
      }
      else {
        this.sentenceArea.addValue(` ${gameData.gameType === ADDITION ? '+' : '\u00D7'} ${value}`);
      }
    }

    if (gameData.gameType === ADDITION) {
      this.currentSentenceValue += value;
    }
    else if (gameData.gameType === MULTIPLICATION) {
      this.currentSentenceValue *= value;
    }

    // we should not be using on 1 tile for registering a "hit"
    if (this.playingGrid.tilesSelected.length === 1) return;

    if (this.currentSentenceValue === this.targetNumberSign.getValue()) {

      this.playingGrid.targetHit(true);
      this.targetNumberSign.setValue('');

      this.time.addEvent({ delay: 1000, callback: () => {this.generateTargetNumber();} });
    }
  }

  generateTargetNumber() {

    // erase sentence area
    this.currentSentenceValue = gameData.gameType === ADDITION ? 0 : 1;
    this.sentenceArea.setValue('');

    // next target number
    const targetNumber = this.playingGrid.findValidTargetNumber();

    if (targetNumber === -1) {

      return;
    }

    this.targetNumberSign.setValue(targetNumber);
  }

  tilesErased(event) {
    this.sentenceArea.setValue('');
    this.currentSentenceValue = gameData.gameType === ADDITION ? 0 : 1;
  }

  levelCompleted() {

    // we'll advance the CURRENT_LEVEL in score screen

    const secondsLeft = this.textTimer.getTimeLeft();
    gameData.BONUS_TIME = secondsLeft;

    const score = this.scoreSign.getValue();
    gameData.LEVEL_SCORE = score;

    gameData.STARS_COLLECTED = this.starsCollected;

    this.scene.start(BonusScreen.KEY);

  }

  cleanUp(nextStep) {

    this.tweens.killAll();
    this.scene.start(nextStep);
  };

  targetHit(value) {

    const currentValue = this.scoreSign.getValue();

    this.scoreSign.countToValue(currentValue + value);
  }

  /*

    toggleMusic(){
        if(game.themePlaying == true){
            game.themePlaying = false;
            var event = new createjs.Event("TOGGLE_MUSIC");
            event._musicOn = false;
            this.dispatchEvent(event);
            this.hud.showMusicState(false)
        } else {
            game.themePlaying = true;
            var event = new createjs.Event("TOGGLE_MUSIC");
            event._musicOn = true;
            this.dispatchEvent(event);
            this.hud.showMusicState(true);

        }
    };

  */
}